import { render } from "./AddReceptionGlobalPage.vue?vue&type=template&id=d29e61da&ts=true"
import script from "./AddReceptionGlobalPage.vue?vue&type=script&lang=ts"
export * from "./AddReceptionGlobalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__